<template>
  <div class="zwx-dialog">
    <el-dialog :visible.sync="visible" :title="title" width="60%" @opened="opened()"
               @close="close()" @cancel="cancel()" :close-on-click-modal="false" :destroy-on-close="true"
               :append-to-body="appendToBody" :show-close="ifShowClose" :before-close="cancel">
      <zwx-scrollbar-y class="dialog-scrollbar-y" ref="msDialogScrollbarY">
        <slot/>
      </zwx-scrollbar-y>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between">
        <div>
          <div style="padding-left: 14px" v-if="pagination">
            <base-pagination :background="false" :parentPage="currentPage" :pageSize="pageSize" :total="total"
                           @currentChange="currentChange"/>
          </div>
          <div style="margin-left: 14px" v-if="previousVisible">
            <el-button class="zwx-button zwx-button-32" @click="previous()">上一步 </el-button>
          </div>
          <slot name="footer" v-else/>
        </div>
        <div style="margin-right: 20px">
          <el-button class="zwx-button zwx-button-32" v-if="nextVisible" type="primary" @click="next()"
                     :disabled="nextDisabled">下一步{{selectedNum!=''?'('+selectedNum+')':''}}</el-button>
          <el-button class="zwx-button zwx-button-32" v-if="submitVisible" type="primary" @click="submit()">确定</el-button>
          <el-button class="zwx-button zwx-button-32" @click="cancel()">取消</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'StepDialog',
  props: {
    title: {type: String, default: ''},
    pagination: {type: Boolean, default: false},
    currentPage: {type: Number},
    pageSize: {type: Number},
    total: {type: Number},
    previousVisible: {type: Boolean, default: false},
    nextVisible: {type: Boolean, default: true},
    nextDisabled: {type: Boolean, default: true},
    selectedNum:{type: String, default: ''},
    submitVisible: {type: Boolean, default: true},
    appendToBody: {type: Boolean, default: false},
    ifShowClose: {type: Boolean, default: true},
  },
  data() {
    return {
      visible: false,
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.$emit('currentPages', currentPage)
    },
    show(visible) {
      this.visible = visible
    },
    previous() {
      this.$emit('previous')
    },
    next() {
      this.$emit('next')
    },
    submit() {
      this.$emit('submit')
    },
    cancel() {
      this.$emit('cancel')
    },
    opened() {
      this.$emit('opened')
    },
    close() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__footer {
  border-top: unset !important;
}
</style>

<style lang="less">
.dialog-scrollbar-y .el-scrollbar__wrap {
  max-height: 64vh !important;
}
</style>
